import { ChannelType, PlanAction, PlanType } from "@/app/common/types";

export const PlanTypeIcon: Record<PlanType, string> = {
  [PlanType.Digital]: "digital.png",
  [PlanType.Voice]: "voice.png",
  [PlanType.DigitalVoice]: "digital+voice.png",
  [PlanType.AllInOne]: "all-in-one.png",
};

export const ChannelTypeIcon: Record<ChannelType, string> = {
  [ChannelType.WhatsApp]: "WhatsApp",
  [ChannelType.Email]: "Correo",
  [ChannelType.Messenger]: "Messenger",
  [ChannelType.Webchat]: "Chat Inbound",
  [ChannelType.Telefonia]: "Telefonica",
  [ChannelType.Sms]: "SMS",
  [ChannelType.Instagram]: "instagram",
};

export const ChannelTypeText: Record<ChannelType, string> = {
  [ChannelType.WhatsApp]: "WhatsApp",
  [ChannelType.Email]: "Correo",
  [ChannelType.Messenger]: "Facebook",
  [ChannelType.Webchat]: "Webchat",
  [ChannelType.Telefonia]: "Telefonica",
  [ChannelType.Sms]: "SMS",
  [ChannelType.Instagram]: "Instagram",  
};

export const PlanActionSubtitle: Record<PlanAction, string> = {
  [PlanAction.Edit]: '',
  [PlanAction.Downgrade]: 'Downgrade a: ',
  [PlanAction.Upgrade]: 'Upgrade a:',
  [PlanAction.EditionActive]: 'Plan editado:',
}